/* eslint-disable import/no-unused-modules */
import React, { useEffect, useState } from 'react'

import { COLORS, styled } from '../../../../../theme'
import {
  ButtonPrimary,
  ButtonSecondary,
  CloseIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlexLayout,
  Typography,
} from '../../../..'
import { ListFieldColumnDefinition, ListFieldRowDefinition } from '../../definitions'
import { ConditionalFormRenderer } from './ConditionalRenderer'

const DialogTitleLayout = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const CloseButton = styled('div')`
  cursor: pointer;
`

const DialogBody = styled(DialogContent)`
  padding: 20px 20px 0;
  max-width: 500px;
  border-top: 1px solid ${COLORS.divider};
  border-bottom: 1px solid ${COLORS.divider};
`
const StyledFlexLayout = styled(FlexLayout)`
  gap: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
`

interface TherapyModalProps {
  title: string
  editModalOpen: boolean
  currentEditId?: string | null
  fields: ListFieldColumnDefinition[]
  getRow: (id: string) => ListFieldRowDefinition | undefined
  handleCloseEditElementModal: (save?: boolean, value?: EditFormState) => void
}

export interface EditFormState {
  [key: string]: any
}

export const EditRowDataModal = ({
  title,
  editModalOpen,
  currentEditId,
  fields,
  getRow,
  handleCloseEditElementModal,
}: TherapyModalProps) => {
  const [editFormState, setFormState] = useState<EditFormState>({})

  useEffect(() => {
    if (currentEditId) {
      const row = getRow(currentEditId)
      if (row) {
        const formState: EditFormState = {}
        fields.forEach((field) => {
          formState[field.name] = row[field.name]
        })
        setFormState(formState)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEditId])

  const [validForm, setValidForm] = useState<boolean>(false)

  useEffect(() => {
    const isValid = fields
      .filter((field) => field.mandatory)
      .every(
        (field) =>
          editFormState[field.name] !== undefined &&
          editFormState[field.name] !== null &&
          editFormState[field.name] !== '',
      )
    setValidForm(isValid)
  }, [editFormState, fields])

  const handleClose = (save?: boolean) => {
    if (save && editFormState) {
      handleCloseEditElementModal(true, editFormState)
    }
    handleCloseEditElementModal()
  }

  return (
    <Dialog
      open={editModalOpen}
      onClose={() => {
        handleClose()
      }}
    >
      <DialogTitle>
        <DialogTitleLayout>
          <Typography data-test-id="action-row-modal-title" itemType="h3">
            {currentEditId ? `Edit ${title}` : `Add ${title}`}
          </Typography>
          <CloseButton data-test-id="button-close_edit_row_modal" onClick={() => handleClose()}>
            <CloseIcon />
          </CloseButton>
        </DialogTitleLayout>
      </DialogTitle>
      <DialogBody>
        <StyledFlexLayout>
          <ConditionalFormRenderer
            editFormState={editFormState}
            handleSetEditFormState={(value: any) => setFormState(value)}
            fields={fields}
          />
        </StyledFlexLayout>
      </DialogBody>
      <DialogActions>
        <ButtonSecondary data-test-id="edit_row_data_modal-cancel_button" onClick={() => handleClose()}>
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          data-test-id="edit_row_data_modal-save_button"
          onClick={() => handleClose(true)}
          disabled={!validForm}
        >
          Save
        </ButtonPrimary>
      </DialogActions>
    </Dialog>
  )
}
